import { GetterTree } from 'vuex';
import { IVuexRootStoreState, IWorkOrderTemplateState } from '@/types';

export const templateGetters: GetterTree<IWorkOrderTemplateState, IVuexRootStoreState> = {
  getWorkOrderTemplates: (state) => state.templates,
};
